<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems" class="breadcrumb mx-16">
    </v-breadcrumbs>
    <v-card style="border-radius: 15px" class="mx-16">
      <v-row class="d-flex justify-center mx-4 v-step-0" dense>
        <v-col cols="12" sm="12" md="5" xl="5" class="mt-2">
          <v-combobox
            v-model="selectedGene"
            outlined
            rounded
            dense
            clearable
            clear-icon="mdi-close-circle"
            :loading="gene_loading"
            :items="gene_items"
            :search-input.sync="gene_search"
            label="Gene Name"
            :messages="gene_message"
            :error-messages="gene_error_message"
          >
          </v-combobox>
        </v-col>
        <v-col cols="12" sm="12" md="5" xl="5" class="mt-2">
          <v-combobox
            v-model="selectedIsoform"
            outlined
            rounded
            dense
            clearable
            clear-icon="mdi-close-circle"
            :loading="isoform_loading"
            :items="isoform_items"
            :search-input.sync="isoform_search"
            label="Transcript Name"
            :messages="isoform_message"
            :error-messages="isoform_error_message"
          >
          </v-combobox>
        </v-col>
      </v-row>

      <v-row dense class="d-flex justify-center">
        <v-col cols="12" sm="12" md="12" xl="12">
          <!-- <v-card outlined
                  elevation="3"> -->
          <!-- <v-card-title class="justify-center font-weight-bold grey lighten-2">
              Isoform‑specific protein-protein interactions network
            </v-card-title> -->
          <div class="d-flex flex-row select-input">
            <v-select
              v-model="node_num"
              label="PPI Numbels"
              outlined
              rounded
              dense
              :items="node_nums"
              class="v-step-3"
            >
            </v-select>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="download ml-3"
                  color="info"
                  @click="downloadPPI"
                  x-small
                  fab
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>download</span><br />
            </v-tooltip>
          </div>

          <v-progress-circular
            v-show="isShowProgress"
            style="left: 47%"
            :rotate="-90"
            :size="80"
            :width="10"
            color="primary"
            indeterminate
          >
          </v-progress-circular>

          <!-- <v-slider v-model="node_num"
                      label="PPI Numbers"
                      min="10"
                      max="50"
                      step="5"
                      thumb-label="always"
                      thumb-color="primary"
                      tick-size="4"
                      color="primary"
                      style="width:50%"
                      class="d-flex justify-center"
                      >
            </v-slider> -->
          <div id="stringEmbedded" class="v-step-2"></div>
          <!-- </v-card> -->
        </v-col>

        <v-col
          cols="12"
          sm="12"
          md="8"
          xl="8"
          class="d-flex justify-center mt-2 v-step-1"
          v-if="isoform_miss_inter && isoform_miss_inter.length > 0"
        >
          <div>
            <v-card-title class="justify-center font-weight-bold grey lighten-2"
              >Missing isoform-specific PPIs ({{
                isoform_miss_inter && isoform_miss_inter.length
              }})</v-card-title
            >
            <v-data-table
              dense
              :headers="miss_headers"
              fixed-header
              :items="isoform_miss_inter"
              v-model="miss_selected_row"
              :search="miss_search"
              :loading="miss_loading"
              loading-text="Loading... Please wait"
              no-data-text="There is no missing isoform specific interactions."
            >
              <template v-slot:item="{ item }">
                <tr v-show="item.PPI.split(' --- ').length == 2">
                  <td>
                    <a
                      @click="goToGeneSearchResult(item.PPI.split(' --- ')[0])"
                      >{{ item.PPI.split(" --- ")[0] }}</a
                    >
                    ---
                    <a
                      @click="goToGeneSearchResult(item.PPI.split(' --- ')[1])"
                      >{{ item.PPI.split(" --- ")[1] }}</a
                    >
                  </td>
                  <td>
                    <a
                      :href="
                        pfam_url + item.DDI.split(' --- ')[0].split(' (')[0]
                      "
                      target="_blank"
                      >{{ item.DDI.split(" --- ")[0] }}</a
                    >
                    ---
                    <a
                      :href="
                        pfam_url + item.DDI.split(' --- ')[1].split(' (')[0]
                      "
                      target="_blank"
                      >{{ item.DDI.split(" --- ")[1] }}</a
                    >
                  </td>
                  <td>{{ item.string_score }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="12"
          md="8"
          xl="8"
          class="d-flex justify-center mt-2 v-step-1"
          v-if="isoform_exist_inter && isoform_exist_inter.length > 0"
        >
          <div>
            <v-card-title class="justify-center font-weight-bold grey lighten-2"
              >Retained isoform-specific PPIs ({{
                isoform_exist_inter && isoform_exist_inter.length
              }})</v-card-title
            >
            <v-data-table
              dense
              :headers="exist_headers"
              fixed-header
              :items="isoform_exist_inter"
              v-model="exist_selected_row"
              :search="exist_search"
              :loading="exist_loading"
              loading-text="Loading... Please wait"
              no-data-text="There is no retained isoform specific interactions."
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>
                    <a
                      @click="goToGeneSearchResult(item.PPI.split(' --- ')[0])"
                      >{{ item.PPI.split(" --- ")[0] }}</a
                    >
                    ---
                    <a
                      @click="goToGeneSearchResult(item.PPI.split(' --- ')[1])"
                      >{{ item.PPI.split(" --- ")[1] }}</a
                    >
                  </td>
                  <td>
                    <a
                      :href="
                        pfam_url + item.DDI.split(' --- ')[0].split(' (')[0]
                      "
                      target="_blank"
                      >{{ item.DDI.split(" --- ")[0] }}</a
                    >
                    ---
                    <a
                      :href="
                        pfam_url + item.DDI.split(' --- ')[1].split(' (')[0]
                      "
                      target="_blank"
                      >{{ item.DDI.split(" --- ")[1] }}</a
                    >
                  </td>
                  <td>{{ item.string_score }}</td>
                </tr>
              </template>
            </v-data-table>
            <!-- </v-card-text> -->
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- User guide -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="guide-btn-style primary"
          fab
          small
          icon
          v-bind="attrs"
          v-on="on"
          @click="$tours['myTour'].start()"
        >
          <v-icon color="white">mdi-book-cog</v-icon>
        </v-btn>
      </template>
      <span>User Guide</span>
    </v-tooltip>

    <v-tour
      name="myTour"
      :steps="steps"
      :options="{ highlight: true }"
    ></v-tour>

    <!-- back to top -->
    <back-to-top></back-to-top>
  </v-container>
</template>

<script>
// import { getSTRING } from '../../js/string_embedded_network_es6.js';
// import { getAllGeneFromSV } from 'node/appbar.js'
import {
  getAllCancerGeneCensus,
  getAllGeneIdFromIsoformSpecificPPI,
  getAllTranscriptIdFromIsoformSpecificPPI,
  getAllTranscriptIdByGeneId,
  getIsoformSpecificPPIByTranscriptId,
} from "node/spliceinteraction.js";
import * as d3 from "d3-selection";
import BackToTop from "@/components/main/BackToTop";
// import bus from "@/js/eventBus";

export default {
  name: "SpliceInteraction",
  components: {
    BackToTop,
  },
  data() {
    return {
      breadItems: [
        {
          text: "Home",
          disabled: false,
          href: "/ascancer/home",
        },
        {
          text: "Toolkit",
          disabled: false,
          href: "/ascancer/tools",
        },
        {
          text: "Isoform-specific PPIs Network",
          disabled: true,
        },
      ],

      steps: [
        {
          target: ".v-step-0",
          content: `1. Input the <span class='font-weight-bold info--text'>Gene Name</span> or <span class='font-weight-bold info--text'>Transcript Name</span> !`,
          params: {
            placement: "bottom",
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-1",
          content: `2. Show the details of <span class='font-weight-bold red--text'>Missing isoform-specific PPIs</span> or 
        <span class='font-weight-bold info--text'>Retained isoform-specific PPIs</span> based on the selected Transcript Name!<br/>`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-2",
          content: `3. Show the <span class='font-weight-bold info--text'>STRING PPIs network</span> based on the selected Gene Name.<br/>
        <span class='font-weight-bold red--text'>Red dashed edges</span> represent the missing PPIs of the selected Transcript Name.<br/>
        <span class='font-weight-bold info--text'>Blue edges</span> represent the retained PPIs of the selected Transcript Name.<br/>
        <span class='font-weight-bold red--text'>Red node</span> represents the selected Gene.<br/>
        <span class='font-weight-bold info--text'>Blue nodes</span> belongs to the COSMIC Cancer Gene Census.<br/>
        <span class='font-weight-bold white--text'>White nodes</span> represents the other Genes.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-3",
          content: `4. Select the number of PPIs to show. The dafault is 10.`,
          params: {
            enableScrolling: false,
          },
        },
      ],

      selectedGene: "RAC1 | ENSG00000136238",
      gene_search: null,
      gene_list: [],
      gene_items: [],
      gene_loading: false,
      gene_message: null,
      gene_error_message: null,

      selectedIsoform: "RAC1-001 | ENST00000348035",
      isoform_search: null,
      isoform_list: [],
      isoform_items: [],
      isoform_loading: false,
      isoform_message: null,
      isoform_error_message: null,

      cancer_gene_census: [],
      isoform_specific_network: [],
      isoform_miss_inter: [],
      isoform_exist_inter: [],

      node_num: 10,
      node_nums: [10, 20, 30, 40, 50],

      miss_headers: [
        {
          text: "Protein-Protein Interactions",
          value: "PPI",
          align: "start",
          sortable: true,
        },
        {
          text: "Domain-Domain Interactions",
          value: "DDI",
          align: "start",
          sortable: true,
        },
        {
          text: "String Score",
          value: "string_score",
          align: "start",
          sortable: true,
        },
      ],
      miss_selected_row: [],
      miss_search: null,
      miss_loading: true,

      exist_headers: [
        {
          text: "Protein-Protein Interactions",
          value: "PPI",
          align: "start",
          sortable: true,
        },
        {
          text: "Domain-Domain Interactions",
          value: "DDI",
          align: "start",
          sortable: true,
        },
        {
          text: "String Score",
          value: "string_score",
          align: "start",
          sortable: true,
        },
      ],
      exist_selected_row: [],
      exist_search: null,
      exist_loading: true,

      pfam_url: "http://pfam.xfam.org/family/",

      isShowProgress: true,
    };
  },
  created() {
    this.getAllGeneIdFromIsoformSpecificPPI();
    this.getAllTranscriptIdByGeneId();

    // Load the external script file
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://ngdc.cncb.ac.cn/ascancer/api/js/combined_embedded_network_v2.0.2.js";
    document.body.appendChild(script);

    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src =
      "https://ngdc.cncb.ac.cn/ascancer/api/js/pdfkit.standalone.js";
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = "https://ngdc.cncb.ac.cn/ascancer/api/js/svg-to-pdfkit.js";
    document.body.appendChild(script2);
  },
  mounted() {
    // let self = this;
    // // self.$tours['myTour'].start();
    // bus.$on('guide', function (data) {
    //   console.log(data)
    //   self.guide_message = data;
    //   if (data == "success") {
    //     console.log('yes');
    //     console.log(self);
    //     console.log(self.guide_message);
    //     self.$tours['myTour'].start();
    //   }
    // });

    this.getAllTranscriptIdFromIsoformSpecificPPI(); // 加载时间过久导致 隐藏的 bug， 基因名字闪退

    // plot the PPI plot
    // let protein = [this.selectedGene && this.selectedGene.split(' | ')[0]];
    // let node_num = this.node_num;
    // this.plotPPI(protein, node_num);
    // this.invokeIsonet();
    this.updatePPINetwork();
  },
  watch: {
    gene_search(val) {
      val && val !== this.selectedGene && this.geneQuerySelections(val);
    },
    isoform_search(val) {
      val && val !== this.selectedIsoform && this.isoformQuerySelections(val);
    },
    selectedGene(val) {
      // console.log(val);
      if (val == null) {
        this.selectedIsoform = null;
        this.gene_message = "Please input the gene name.";
      } else if (val && this.gene_list.includes(val)) {
        this.selectedGene = val;
        this.gene_message = null;
        this.items_isoform = [];
        this.getAllTranscriptIdByGeneId();
      } else {
        // window.alert("Sorry, we cant' find this gene.");
        this.selectedGene = null;
      }
    },
    selectedIsoform(val) {
      if (val == null) {
        this.selectedGene = null;
        this.isoform_message = "Please input the transcript name.";
      } else if (val && this.isoform_list.includes(val)) {
        this.selectedIsoform = val;
        this.isoform_message = null;
        // update the missed and retained PPI,
        // update the selectedGene
        // update the network
        this.updatePPINetwork();

        // update the network, 以下代码合并到 updatePPINetwork 函数里
        // this.destroyPPI();
        // getIsoformSpecificPPIByTranscriptId() 为异步方法，需等待基因更新完毕！
        // setTimeout(() => {
        //   let protein = [this.selectedGene && this.selectedGene.split(' | ')[0]];
        //   console.log(protein);
        //   let node_num = this.node_num;
        //   this.plotPPI(protein, node_num);
        //   this.invokeIsonet();
        // }, 1000);
      } else {
        // window.alert("Sorry, we cant' find this transcript name.");
        this.selectedIsoform = null;
      }
    },
    node_num(newValue, oldValue) {
      if (newValue != oldValue) {
        this.destroyPPI(); // destroy before's STRING network
        let protein = [this.selectedGene && this.selectedGene.split(" | ")[0]];
        this.plotPPI(protein, newValue); // plot new STRING network
        this.invokeIsonet(); //
      }
    },
    isoform_miss_inter(val) {
      if (val) {
        this.miss_loading = false;
      }
    },
    isoform_exist_inter(val) {
      if (val) {
        this.exist_loading = false;
      }
    },
  },
  methods: {
    // async getAllGeneFromSV() {
    //   await getAllGeneFromSV().then(data => {
    //     // console.log(data);
    //     if (data) {
    //       this.gene_list = [...data[0]];
    //     }
    //   }).catch(err => console.error(err))
    // },
    async getAllGeneIdFromIsoformSpecificPPI() {
      await getAllGeneIdFromIsoformSpecificPPI()
        .then((data) => {
          // console.log(data);
          if (data) {
            this.gene_list = data;
          }
        })
        .catch((err) => console.error(err));
    },
    async getAllTranscriptIdFromIsoformSpecificPPI() {
      await getAllTranscriptIdFromIsoformSpecificPPI()
        .then((data) => {
          // console.log(data);
          if (data) {
            this.isoform_list = data;
          }
        })
        .catch((err) => console.error(err));
    },
    async getAllTranscriptIdByGeneId() {
      //   console.log(this.selectedGene);
      if (this.selectedGene) {
        await getAllTranscriptIdByGeneId(this.selectedGene)
          .then((data) => {
            // console.log(data);
            if (data) {
              let isoform_items = [];
              data.forEach((v, i, a) => {
                isoform_items.push(v.transcript_id);
              });
              isoform_items = isoform_items.sort();
              // console.log(isoform_items);
              this.isoform_items = isoform_items;
              // if isoform_items don't includes isoform_now, select the first isoform defaultly
              let isoform_now = this.selectedIsoform;
              if (!isoform_items.includes(isoform_now)) {
                this.selectedIsoform = isoform_items[0];
              }
            }
          })
          .catch((err) => console.error(err));
      }
    },
    async updatePPINetwork() {
      // this.isShowProgress = true;

      if (this.selectedIsoform) {
        // change route
        this.changeRoute();

        await getIsoformSpecificPPIByTranscriptId(this.selectedIsoform)
          .then((data) => {
            // console.log(data);
            if (data) {
              this.isoform_specific_network = data;
              // console.log(data[0].isoform_miss_ppi);
              this.isoform_miss_inter = data[0].isoform_miss_ppi.filter((d) => {
                return d.PPI.split(" --- ")[1] != "";
              });
              this.isoform_exist_inter = data[0].isoform_exist_ppi.filter(
                (d) => {
                  return d.PPI.split(" --- ")[1] != "";
                }
              );
              // this.isoform_miss_inter = data[0].isoform_miss_ppi;
              // this.isoform_exist_inter = data[0].isoform_exist_ppi;

              this.selectedGene = data[0].gene_id; // update the gene name input
              // console.log(this.selectedGene);

              // update the STRING network based on the selectedGene
              this.destroyPPI();
              let protein = [
                this.selectedGene && this.selectedGene.split(" | ")[0],
              ];
              // console.log(protein);
              let node_num = this.node_num;
              this.plotPPI(protein, node_num);
              this.invokeIsonet();
            }
          })
          .catch((err) => console.error(err));
      }
    },
    geneQuerySelections(v) {
      this.gene_message = null;
      this.gene_error_message = null;
      this.gene_loading = true;
      setTimeout(() => {
        this.gene_items = this.gene_list.filter((e) => {
          let pattern = new RegExp(v, "ig");
          // return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
          return pattern.test(e);
        });
        this.gene_loading = false;
        // show the no data tips when the search result is null
        if (this.gene_items.length == 0) {
          this.gene_error_message = "Sorry, we cant' find this gene.";
        }
      }, 500);
    },
    isoformQuerySelections(v) {
      this.isoform_message = null;
      this.isoform_error_message = null;
      this.isoform_loading = true;
      setTimeout(() => {
        this.isoform_items = this.isoform_list.filter((e) => {
          let pattern = new RegExp(v, "ig");
          // return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) === 0
          return pattern.test(e);
        });
        this.isoform_loading = false;
        // show the no data tips when the search result is null
        if (this.isoform_items.length == 0) {
          this.isoform_error_message = "Sorry, we cant' find this Transcript.";
        }
      }, 500);
    },
    invokeIsonet() {
      this.isShowProgress = true;
      // let stringNetwork = document.getElementById('svg_network_image'); // 此处不能以是否存在 id="svg_network_image" 为判断标准
      let stringNetwork = document.getElementById("nodes"); // 应以是否存在 id="nodes" 为判断标准
      // console.log(stringNetwork);
      if (stringNetwork == null) {
        setTimeout(this.invokeIsonet, 10);
      } else {
        d3.select("svg#svg_network_image").style("visibility", "hidden"); // hide network
        // decorate the network, change the nodes and edges style based on missed_PPI and retained_PPI
        this.isonet().then(() => {
          this.plotLegend(); // plot legend and translate network
        });
      }
    },
    async isonet() {
      // console.log("hahaha");
      let genename_searched = this.selectedGene;
      if (genename_searched) {
        genename_searched = genename_searched.split(" | ")[0]; // only retain the gene_name
      }
      // console.log(genename_searched);

      let cgc_list;
      await getAllCancerGeneCensus()
        .then((data) => {
          // console.log(data);
          this.cancer_gene_census = data;
          cgc_list = data.filter((g) => g != genename_searched); // delete the interest gene in cancer_gene_census
        })
        .catch((err) => console.error(err));
      //   console.log(cgc_list);
      //   console.log(cgc_list.length);

      let isoform_miss_inter = this.isoform_miss_inter;
      let isoform_exist_inter = this.isoform_exist_inter;
      // console.log(this.isoform_miss_inter);
      // console.log(this.isoform_exist_inter);

      let miss_partners = [];
      if (isoform_miss_inter.length > 0) {
        isoform_miss_inter.forEach((miss, index, array) => {
          miss_partners.push(miss.PPI.split(" --- ")[1]);
        });
      }
      miss_partners = [...new Set(miss_partners)];
      // console.log(miss_partners);

      let exist_partners = [];
      if (isoform_exist_inter.length > 0) {
        isoform_exist_inter.forEach((exist, index, array) => {
          exist_partners.push(exist.PPI.split(" --- ")[1]);
        });
      }
      exist_partners = [...new Set(exist_partners)];
      // console.log(exist_partners);

      let protein_nodes = document.getElementsByClassName("nwnodecontainer");
      // console.log(protein_nodes);

      // 1. get the search gene's geneid
      // 2. Set different node color based on the node gene category (searched_gene or cancer_gene_census)
      let geneid_searched;
      if (protein_nodes.length > 0) {
        protein_nodes.forEach((protein_node, index, array) => {
          let protein_name = protein_node.getAttribute("data-safe_div_label");

          if (cgc_list.includes(protein_name)) {
            document
              .getElementsByClassName("nwbubblecoloredcircle")
              [index].setAttribute("fill", "#90CAF9");
          }

          if (protein_name == genename_searched) {
            document
              .getElementsByClassName("nwbubblecoloredcircle")
              [index].setAttribute("fill", "#EF9A9A");
            // get the search gene's geneid
            geneid_searched = protein_node.getAttribute("id").split(".").pop();
          }
        });
      }
      // console.log(geneid_searched);

      // change the edge style between exist_partners and searched_gene
      for (let i = 0; i < exist_partners.length; i++) {
        let partner_name = exist_partners[i];
        let geneName, partner_id;
        for (let j = 0; j < protein_nodes.length; j++) {
          geneName = protein_nodes[j].getAttribute("data-safe_div_label");
          if (partner_name == geneName) {
            partner_id = protein_nodes[j].getAttribute("id").split(".").pop();

            let elem0 = document.getElementById(
              "line" + "." + geneid_searched + "." + partner_id + "." + "0"
            );
            let elem1 = document.getElementById(
              "line" + "." + geneid_searched + "." + partner_id + "." + "1"
            );
            let elem2 = document.getElementById(
              "line" + "." + partner_id + "." + geneid_searched + "." + "0"
            );
            let elem3 = document.getElementById(
              "line" + "." + partner_id + "." + geneid_searched + "." + "1"
            );

            if (elem0 !== null) {
              elem0.setAttribute("stroke", "#90CAF9");
              elem0.setAttribute("stroke-opacity", "1");
              elem0.setAttribute("stroke-width", "10");
              elem1.setAttribute("stroke", "#90CAF9");
              elem1.setAttribute("stroke-opacity", "1");
              elem1.setAttribute("stroke-width", "10");
            }

            if (elem2 !== null) {
              elem2.setAttribute("stroke", "#90CAF9");
              elem2.setAttribute("stroke-opacity", "1");
              elem2.setAttribute("stroke-width", "10");
              elem3.setAttribute("stroke", "#90CAF9");
              elem3.setAttribute("stroke-opacity", "1");
              elem3.setAttribute("stroke-width", "10");
            }
          }
        }
      }

      // change the edge style between miss_partners and searched_gene
      for (let i = 0; i < miss_partners.length; i++) {
        let partner_name = miss_partners[i];
        let geneName, partner_id;
        for (let j = 0; j < protein_nodes.length; j++) {
          geneName = protein_nodes[j].getAttribute("data-safe_div_label");
          if (partner_name == geneName) {
            partner_id = protein_nodes[j].getAttribute("id").split(".").pop();

            let elem0 = document.getElementById(
              "line" + "." + geneid_searched + "." + partner_id + "." + "0"
            );
            let elem1 = document.getElementById(
              "line" + "." + geneid_searched + "." + partner_id + "." + "1"
            );
            let elem2 = document.getElementById(
              "line" + "." + partner_id + "." + geneid_searched + "." + "0"
            );
            let elem3 = document.getElementById(
              "line" + "." + partner_id + "." + geneid_searched + "." + "1"
            );

            if (elem0 !== null) {
              elem0.setAttribute("stroke", "#EF9A9A");
              elem0.setAttribute("stroke-opacity", "1");
              elem0.setAttribute("stroke-width", "10");
              elem0.setAttribute("stroke-dasharray", "10,5");

              elem1.setAttribute("stroke", "#EF9A9A");
              elem1.setAttribute("stroke-opacity", "1");
              elem1.setAttribute("stroke-width", "10");
              elem1.setAttribute("stroke-dasharray", "10,5");
            }

            if (elem2 !== null) {
              elem2.setAttribute("stroke", "#EF9A9A");
              elem2.setAttribute("stroke-opacity", "1");
              elem2.setAttribute("stroke-width", "10");
              elem2.setAttribute("stroke-dasharray", "10,5");

              elem3.setAttribute("stroke", "#EF9A9A");
              elem3.setAttribute("stroke-opacity", "1");
              elem3.setAttribute("stroke-width", "10");
              elem3.setAttribute("stroke-dasharray", "10,5");
            }
          }
        }
      }
    },
    plotPPI(protein, node_num) {
      // let protein = ['TP53']
      // let protein;
      // protein need to transform as array
      // protein = [this.selectedGene && this.selectedGene.split(' | ')[0]];
      // console.log(protein);
      getSTRING("https://string-db.org", {
        species: "9606",
        identifiers: protein,
        network_flavor: "confidence",
        caller_identity: "www.awesome_app.org",
        required_score: 900,
        add_nodes: node_num,
      });
      // setTimeout(() => {
      //   d3.select('svg#svg_network_image').style('visibility', 'visible'); // show
      //   d3.select('g.svgstringlogo').style('visibility', 'hidden'); // hide string logo
      //   let height = document.getElementById("stringEmbedded").getBoundingClientRect().height; // get svg height
      //   let width = document.getElementById("stringEmbedded").getBoundingClientRect().width; // get svg width
      //   height = height + 50;
      //   width = width * 0.2;

      //   // (hight + 50px) for the legend
      //   let svg = d3.select('svg#svg_network_image');
      //   svg.attr("height", height).attr("width", "100%");

      //   // tranlate nodes and edges
      //   let svg_node = d3.select('g#nodes');
      //   let svg_edge = d3.select('g#edges');
      //   svg_node.attr('transform', `translate(${width},0)`);
      //   svg_edge.attr('transform', `translate(${width},0)`);
      //   // console.log(svg);

      //   // Add legend
      //   // svg.append('g')
      //   //   .attr("class", "legend-background")
      //   //   .append("rect")
      //   //   .attr('x', '10%')
      //   //   .attr('y', '90%')
      //   //   .attr('width', '77%')
      //   //   .attr('height', '50px')
      //   //   .attr('rx', 1) // set border-radius
      //   //   .attr('stroke', '#90CAF9') // set border color
      //   //   .attr('stroke-dasharray', '3,3') // set border color
      //   //   .attr('stroke-width', 0.3) // set border width
      //   //   .attr('fill', '#F5F5F5')
      //   // paint the legend-search-gene
      //   let search_gene_node = svg.append('g').attr("class", "legend-search-gene")
      //   search_gene_node.append("circle")
      //     .attr('cx', '17%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('fill', 'url(#bubble_gradient1)')
      //   search_gene_node.append("circle")
      //     .attr('cx', '17%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('opacity', 0.33)
      //     .attr('fill', 'url(#bubble_gradient2)')
      //   search_gene_node.append("circle")
      //     .attr('class', 'nwbubblecoloredcircle')
      //     .attr('cx', '17%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('fill', '#EF9A9A')
      //   search_gene_node.append("ellipse")
      //     .attr('cx', '17%')
      //     .attr('cy', '93%')
      //     .attr('rx', '11.5')
      //     .attr('ry', '6')
      //     .attr('fill', 'url(#brilliance_gradient)')
      //   // paint the legend-search-gene-text
      //   svg.append('g').attr("class", "legend-search-gene-text")
      //     .append("text")
      //     .attr("x", '20%')
      //     .attr("y", '96%')
      //     .text("Interested Gene")
      //     .attr('font-size', '12px')
      //     .attr('font-weight', 'bold')
      //     .style("font-family", "Arial");
      //   // paint the legend-cgc-gene
      //   let cgc_gene_node = svg.append('g').attr("class", "legend-cgc-gene")
      //   cgc_gene_node.append("circle")
      //     .attr('cx', '30%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('fill', 'url(#bubble_gradient1)')
      //   cgc_gene_node.append("circle")
      //     .attr('cx', '30%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('opacity', 0.33)
      //     .attr('fill', 'url(#bubble_gradient2)')
      //   cgc_gene_node.append("circle")
      //     .attr('class', 'nwbubblecoloredcircle')
      //     .attr('cx', '30%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('fill', '#90CAF9')
      //   cgc_gene_node.append("ellipse")
      //     .attr('cx', '30%')
      //     .attr('cy', '93%')
      //     .attr('rx', '11.5')
      //     .attr('ry', '6')
      //     .attr('fill', 'url(#brilliance_gradient)')
      //   // paint the legend-cgc-gene-text
      //   svg.append('g').attr("class", "legend-cgc-gene-text")
      //     .append("text")
      //     .attr("x", '33%')
      //     .attr("y", '96%')
      //     .text("Cancer Gene Census")
      //     .attr('font-size', '12px')
      //     .attr('font-weight', 'bold')
      //     .style("font-family", "Arial");
      //   // paint the legend-other-gene
      //   let other_gene_node = svg.append('g').attr("class", "legend-other-gene")
      //   other_gene_node.append("circle")
      //     .attr('cx', '45%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('fill', 'url(#bubble_gradient1)')
      //   other_gene_node.append("circle")
      //     .attr('cx', '45%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('opacity', 0.33)
      //     .attr('fill', 'url(#bubble_gradient2)')
      //   other_gene_node.append("circle")
      //     .attr('class', 'nwbubblecoloredcircle')
      //     .attr('cx', '45%')
      //     .attr('cy', '95%')
      //     .attr('r', 20)
      //     .attr('fill', 'rgb(255,255,255)')
      //   other_gene_node.append("ellipse")
      //     .attr('cx', '45%')
      //     .attr('cy', '93%')
      //     .attr('rx', '11.5')
      //     .attr('ry', '6')
      //     .attr('fill', 'url(#brilliance_gradient)')
      //   // paint the legend-other-gene-text
      //   svg.append('g').attr("class", "legend-other-gene-text")
      //     .append("text")
      //     .attr("x", '48%')
      //     .attr("y", '96%')
      //     .text("Other Genes")
      //     .attr('font-size', '12px')
      //     .attr('font-weight', 'bold')
      //     .style("font-family", "Arial");
      //   // paint the legend-missed-ppi
      //   let missed_ppi_edge = svg.append('g').attr("class", "missed-ppi");
      //   missed_ppi_edge.append('rect').attr("x", '56%')
      //     .attr("y", '94%').attr("width", '6%')
      //     .attr("height", '2%').attr('fill', '#EF9A9A')
      //   // paint the legend-missed-ppi-text
      //   svg.append('g').attr("class", "missed-ppi-text")
      //     .append("text")
      //     .attr("x", '64%')
      //     .attr("y", '96%')
      //     .text("Missed PPI")
      //     .attr('font-size', '12px')
      //     .attr('font-weight', 'bold')
      //     .style("font-family", "Arial");
      //   // paint the legend-retained-ppi
      //   let retained_ppi_edge = svg.append('g').attr("class", "retained-ppi");
      //   retained_ppi_edge.append('rect').attr("x", '71%')
      //     .attr("y", '94%').attr("width", '6%')
      //     .attr("height", '2%').attr('fill', 'black')
      //   // paint the legend-retained-ppi-text
      //   svg.append('g').attr("class", "retained-ppi-text")
      //     .append("text")
      //     .attr("x", '79%')
      //     .attr("y", '96%')
      //     .text("Retained PPI")
      //     .attr('font-size', '12px')
      //     .attr('font-weight', 'bold')
      //     .style("font-family", "Arial");
      // }, 3000);
    },
    plotLegend() {
      let height = document
        .getElementById("stringEmbedded")
        .getBoundingClientRect().height; // get svg height
      let width = document
        .getElementById("stringEmbedded")
        .getBoundingClientRect().width; // get svg width
      height = height + 100;
      width = width * 0.22;

      // tranlate nodes and edges
      let svg_node = d3.selectAll("g#nodes > .nwnodecontainer");
      let svg_node_length = svg_node._groups[0].length;
      // console.log(svg_node_length);
      // let svg_edge = d3.select('g#edges');
      // svg_node.attr('transform', `translate(${width},0)`);
      // svg_edge.attr('transform', `translate(${width},0)`);
      // console.log(svg);

      // (hight + 50px) for the legend,
      let svg = d3.select("svg#svg_network_image");
      if (svg_node_length > 41 && svg_node_length <= 51) {
        svg
          .attr("height", height)
          .attr("width", "100%")
          .attr("viewBox", "0, 0, 1000, 1100");
      } else if (svg_node_length > 31 && svg_node_length <= 41) {
        svg
          .attr("height", height)
          .attr("width", "100%")
          .attr("viewBox", "0, 0, 950, 900");
      } else if (svg_node_length > 21 && svg_node_length <= 31) {
        svg
          .attr("height", height)
          .attr("width", "100%")
          .attr("viewBox", "0, 0, 950, 850");
      } else if (svg_node_length > 11 && svg_node_length <= 21) {
        svg
          .attr("height", height)
          .attr("width", "100%")
          .attr("viewBox", "0, 0, 950, 750");
      } else if (svg_node_length > 5 && svg_node_length <= 11) {
        svg
          .attr("height", height)
          .attr("width", "100%")
          .attr("viewBox", "0, 0, 950, 550");
      } else if (svg_node_length > 2 && svg_node_length <= 5) {
        svg
          .attr("height", height)
          .attr("width", "100%")
          .attr("viewBox", "0, 0, 950, 300");
      } else if (svg_node_length == 2) {
        svg
          .attr("height", height)
          .attr("width", "100%")
          .attr("viewBox", "0, 0, 950, 220");
      } else if (svg_node_length == 1) {
        svg
          .attr("height", height)
          .attr("width", "100%")
          .attr("viewBox", "0, 0, 950, 180");
      }

      d3.select("g.svgstringlogo").style("visibility", "hidden"); // hide string logo

      this.isShowProgress = false;
      d3.select("svg#svg_network_image").style("visibility", "visible"); // show

      // Add legend
      // svg.append('g')
      //   .attr("class", "legend-background")
      //   .append("rect")
      //   .attr('x', '10%')
      //   .attr('y', '90%')
      //   .attr('width', '77%')
      //   .attr('height', '50px')
      //   .attr('rx', 1) // set border-radius
      //   .attr('stroke', '#90CAF9') // set border color
      //   .attr('stroke-dasharray', '3,3') // set border color
      //   .attr('stroke-width', 0.3) // set border width
      //   .attr('fill', '#F5F5F5')

      ////// paint the legend //////
      // paint the legend-search-gene
      let search_gene_node = svg
        .append("g")
        .attr("class", "legend-search-gene");
      search_gene_node
        .append("circle")
        .attr("cx", "15%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("fill", "url(#bubble_gradient1)");
      search_gene_node
        .append("circle")
        .attr("cx", "15%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("opacity", 0.33)
        .attr("fill", "url(#bubble_gradient2)");
      search_gene_node
        .append("circle")
        .attr("class", "nwbubblecoloredcircle")
        .attr("cx", "15%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("fill", "#EF9A9A");
      // search_gene_node.append("ellipse")
      //   .attr('cx', '15%')
      //   .attr('cy', '93%')
      //   .attr('rx', '11.5')
      //   .attr('ry', '6')
      //   .attr('fill', 'url(#brilliance_gradient)')
      // paint the legend-search-gene-text
      svg
        .append("g")
        .attr("class", "legend-search-gene-text")
        .append("text")
        .attr("x", "18%")
        .attr("y", "90%")
        .text("Interested Gene")
        .attr("font-size", "12px")
        .attr("font-weight", "bold")
        .attr("font-family", "Arial");

      // paint the legend-cgc-gene
      let cgc_gene_node = svg.append("g").attr("class", "legend-cgc-gene");
      cgc_gene_node
        .append("circle")
        .attr("cx", "31%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("fill", "url(#bubble_gradient1)");
      cgc_gene_node
        .append("circle")
        .attr("cx", "31%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("opacity", 0.33)
        .attr("fill", "url(#bubble_gradient2)");
      cgc_gene_node
        .append("circle")
        .attr("class", "nwbubblecoloredcircle")
        .attr("cx", "31%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("fill", "#90CAF9");
      // cgc_gene_node.append("ellipse")
      //   .attr('cx', '31%')
      //   .attr('cy', '93%')
      //   .attr('rx', '11.5')
      //   .attr('ry', '6')
      //   .attr('fill', 'url(#brilliance_gradient)')
      // paint the legend-cgc-gene-text
      svg
        .append("g")
        .attr("class", "legend-cgc-gene-text")
        .append("text")
        .attr("x", "34%")
        .attr("y", "90%")
        .text("Cancer Gene Census")
        .attr("font-size", "12px")
        .attr("font-weight", "bold")
        .attr("font-family", "Arial");

      // paint the legend-other-gene
      let other_gene_node = svg.append("g").attr("class", "legend-other-gene");
      other_gene_node
        .append("circle")
        .attr("cx", "50%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("fill", "url(#bubble_gradient1)");
      other_gene_node
        .append("circle")
        .attr("cx", "50%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("opacity", 0.33)
        .attr("fill", "url(#bubble_gradient2)");
      other_gene_node
        .append("circle")
        .attr("class", "nwbubblecoloredcircle")
        .attr("cx", "50%")
        .attr("cy", "89%")
        .attr("r", 20)
        .attr("fill", "rgb(255,255,255)");
      // other_gene_node.append("ellipse")
      //   .attr('cx', '50%')
      //   .attr('cy', '93%')
      //   .attr('rx', '11.5')
      //   .attr('ry', '6')
      //   .attr('fill', 'url(#brilliance_gradient)')
      // paint the legend-other-gene-text
      svg
        .append("g")
        .attr("class", "legend-other-gene-text")
        .append("text")
        .attr("x", "53%")
        .attr("y", "90%")
        .text("Other Genes")
        .attr("font-size", "12px")
        .attr("font-weight", "bold")
        .attr("font-family", "Arial");

      // paint the legend-missed-ppi
      let missed_ppi_edge = svg.append("g").attr("class", "missed-ppi");
      // missed_ppi_edge.append('rect').attr("x", '56%')
      //   .attr("y", '94%').attr("width", '6%')
      //   .attr("height", '2%').attr('fill', '#EF9A9A');
      missed_ppi_edge
        .append("line")
        .attr("x1", "62%")
        .attr("y1", "89%")
        .attr("x2", "69%")
        .attr("y2", "89%")
        .attr("stroke", "#EF9A9A")
        .attr("stroke-width", "10")
        .attr("stroke-dasharray", "10,5");
      // paint the legend-missed-ppi-text
      svg
        .append("g")
        .attr("class", "missed-ppi-text")
        .append("text")
        .attr("x", "70%")
        .attr("y", "90%")
        .text("Missing PPI")
        .attr("font-size", "12px")
        .attr("font-weight", "bold")
        .attr("font-family", "Arial");

      // paint the legend-retained-ppi
      let retained_ppi_edge = svg.append("g").attr("class", "retained-ppi");
      // retained_ppi_edge.append('rect').attr("x", '78%')
      //   .attr("y", '94%').attr("width", '6%')
      //   .attr("height", '2%').attr('fill', '#90CAF9')
      retained_ppi_edge
        .append("line")
        .attr("x1", "78%")
        .attr("y1", "89%")
        .attr("x2", "85%")
        .attr("y2", "89%")
        .attr("stroke", "#90CAF9")
        .attr("stroke-width", "10");
      // paint the legend-retained-ppi-text
      svg
        .append("g")
        .attr("class", "retained-ppi-text")
        .append("text")
        .attr("x", "86%")
        .attr("y", "90%")
        .text("Retained PPI")
        .attr("font-size", "12px")
        .attr("font-weight", "bold")
        .attr("font-family", "Arial");
    },
    destroyPPI() {
      d3.select("svg#svg_network_image").selectAll("*").remove();
    },
    goToGeneral(genename) {
      //   console.log(genename);
      this.$router
        .push({
          path: "/tools/general",
          query: {
            genename: genename,
          },
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            logError(err);
          }
        });
    },
    goToGeneSearchResult(genename) {
      if (genename) {
        this.$router
          .push({
            path: "/search",
            query: {
              genename: genename,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      } else if (genename == null || genename == "") {
        window.alert("Sorry, please input the gene name !");
      }
    },
    changeRoute() {
      // console.log('go');
      // let isoform;
      // if (this.selectedIsoform) {
      //   isoform = this.selectedIsoform.split(' | ')[1]
      // }
      this.$router
        .replace({
          path: "/tools/spliceinter",
          query: {
            isoform: this.selectedIsoform,
          },
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            console.error(err);
          }
        });
    },
    svgToPdfExample(svg, name) {
      const doc = new window.PDFDocument();
      const chunks = [];
      const stream = doc.pipe({
        // writable stream implementation
        write: (chunk) => chunks.push(chunk),
        end: () => {
          const pdfBlob = new Blob(chunks, {
            type: "application/octet-stream",
          });
          var blobUrl = URL.createObjectURL(pdfBlob);
          //window.open(`${blobUrl}?customfilename.pdf`);

          /* custom file name download */
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = blobUrl;
          a.download = name; // <---- 👈 file name
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        },
        // readable streaaam stub iplementation
        on: (event, action) => {},
        once: (...args) => {},
        emit: (...args) => {},
      });

      window.SVGtoPDF(doc, svg, 0, 0, { useCSS: true });
      doc.end();
    },
    downloadPPI() {
      // console.log('download');
      let svg = d3.select("div#stringEmbedded > svg")._groups[0][0];
      // console.log(svg);
      let name = this.selectedIsoform + "_PPI.pdf";
      this.svgToPdfExample(svg, name);
    },
  },
};
</script>
<style scoped lang="sass">
@import url('../../sass/floatingDiv.vpy7746.css')

a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

// .v-sheet.v-card
//   border-radius: 15px

.v-card__title
  line-height: 0.5rem

.select-input
  max-width: 30%
  margin-left: 35%

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

// #stringEmbedded
//   display: flex
//   justify-content: center

// set the width of guide
::v-deep .v-step
  max-width: 600px
  text-align: start

// set the style of highlight
.v-tour__target--highlighted
  border: 1px red solid
  border-radius: 0.8rem
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4)

.guide-btn-style
  position: fixed
  right: 1%
  top: 90%
  transform: translateY(-50%)
  z-index: 99
</style>